angular
  .module 'memberPortal'
  .controller 'MemberLoginCtrl', (
    $scope,
    $state,
    $stateParams,
    $http,
    $window,
    DataService
  ) ->
    $scope.data = DataService
    domain = $scope.data.domain
    $state.go('memberPortal.bookings', m: $stateParams.hash) if DataService.isAuthenticated

    clearMessages = ->
      $scope.error = ''
      $scope.notice = ''

    $scope.getHash =  ->
      $stateParams.hash || $stateParams.m

    $scope.login = (pin) ->
      clearMessages()
      hash = $stateParams.hash
      url = "/websites/#{domain}/members/logins/#{hash}"
      $http.put(url, pin: pin).then ->
        url = $state.href 'memberPortal.bookings', m: $stateParams.hash
        $window.open url, '_self'
        true
      , ->
        $scope.error = 'PIN incorrect or account is disabled. Please try again.'

    $scope.sendLoginLink = (email) ->
      clearMessages()
      url = "/websites/#{domain}/members/logins"
      $http.post(url, email: email).then ->
        $scope.notice = 'Login link email sent'
        $scope.email = ''
      , ->
        $scope.error = "Request could not be completed. Please try again"

    $scope.sendPin = (email = '') ->
      clearMessages()
      url = "/websites/#{domain}/members/pins"
      $http.post(url, email: email).then ->
        $scope.notice = 'PIN email sent'
        $scope.email = ''
      , ->
        $scope.error = "Request could not be completed. Please try again."
